import { AutoMap } from "@automapper/classes"
import { BaseDOM } from "../base.dom"

export class Vehicule extends BaseDOM<Vehicule> {

    @AutoMap()
    Plaque!: string
    @AutoMap()
    OdometreDebut!: number
    @AutoMap()
    OdometreFin!: number
}